export default __webpack_public_path__ + "static/media/41.ae917931.jpg";